var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:(_vm.badgeStyles)},[_vm._t("default"),_vm._v(" "),_c('span',{class:_vm.badgeClasses,style:(_vm.backgroundColorStyle)},[_vm._t("label",[_vm._v(_vm._s(_vm.label))])],2)],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67e4703c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/badge/badge.vue
// module id = 709
// module chunks = 0 1 49